// =============================================================================
//  Copyright : 2018-2021 semantics GmbH
//  Date      : $Date: 2021-08-13 15:31:00 +0200 (Fri, 13 Aug 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: a.hesse $
//  Revision  : $Rev: 120867 $
//  Purpose   : viewer package
// =============================================================================
import * as views from './views'
export {views}

export const parts = true

export const jobs = true
